import React from "react";
import blueLoader from "../../assets/loaders/blue.lottie";
import whiteLoader from "../../assets/loaders/white.lottie";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const Loader = ({
  type = "blue",
  noMargin = false,
  tableLoader = false,
  width = "100px",
  height = "100px",
}: {
  type?: "blue" | "white";
  noMargin?: boolean;
  tableLoader?: boolean;
  width?: string;
  height?: string;
}) => {
  return (
    <div
      style={{
        position: tableLoader ? "absolute" : "relative",
        top: tableLoader ? "-200%" : undefined,
        left: tableLoader ? "-200%" : undefined,
        width: width,
        height: height,
      }}
      className={`flex justify-center items-center ${
        noMargin ? "mt-0" : "mt-[200px]"
      }`}
    >
      <DotLottieReact
        src={type === "blue" ? blueLoader : whiteLoader}
        autoplay={true}
        loop
      />
    </div>
  );
};

export default Loader;
